module.exports = __webpack_public_path__ + "media/icon/icon_map_pin-4d6a9f7f.svg";